/**
 * 公共图表组件
 * @description 公共图表组件
 * @author mll
 * @date 2022-12-18
 */

import React from 'react';
import { connect } from 'dva';
import html2canvas from "html2canvas";
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from "@/utils";
let { log, isType } = utils_tool;

import './index.less'

import {
    _basic_check,
    _build_request,
    _doInitRequest,
    _getInitApiParams,
    getSearchMap
} from "./utils";

let { WizContainer } = framework_tool;
let {
    WizButton,
    WizTabs,
    WizIcon,
    WizDropdown,
    WizMenu,
    WizDataSet,
    WizSelect,
    WizCheckbox,
    WizForm
} = component_tool;

class WizCharts extends WizContainer {

    componentName = 'WizCharts';

    constructor(props) {
        super(props);
        this.state = {
            mode: 'chart',//展示形式；table/chart
            show: 'rate',//展示的维度
        }

        let { apis = [] } = props

        //构造参数变化的监控方法
        this.propsAndStateOnChange = {
            mode: this._mode.bind(this),
            dataItems: this._dataItems.bind(this),
            searchMap: this._searchMap.bind(this),
            ...this._buildOnChange(apis, this._commonDataListen),
        };

        //备份初始化的apis的apiParams
        this._initApis = {};
        this._backUpApis = {};
        for (let key in apis) {
            let val = apis[key];
            this._backUpApis[key] = val["payload"]["apiParams"];
            this._initApis[key] = val["payload"]["apiParams"];
        }
    }

    static defaultProps = {
        /**
         * 图表维度配置
         * key:维度的唯一键，用于1展示维度选项 2对应api
         * value:维度的值，用于中文展示
         * chart：图表的类型 ,支持pie: '饼图', line: '折线图', column: '柱状图'等
         */
        dimension: [],
        /**
         * 图表展示需要用到的api数据集合，格式与列表组件格式一致
         */
        apis: {},
        /**
         * api请求时参数格式化方法
         * @param {*} key 
         * @param {*} filter 
         * @returns 
         */
        apiFormat: (key, filter) => { return filter },
        /**
         * api请求后数据格式化方法
         * @param {*} key 
         * @param {*} data 
         * @returns 
         */
        apiDataFormat: (key, data) => { return data },
        /**
         * 图标数据格式化方法
         * @param {*} show 
         * @param {*} data 
         * @returns 
         */
        formatData: (show, data) => { console.log('formatData is not defined：', show, data); return {} },
    };

    /**
    * 构造调用接口后的接收方法
    */
    _buildOnChange = (api, listen) => {
        let r = {}
        for (const key in api) {
            r[key] = listen.bind(this, key)
        }
        return r;
    }

    /**
     * 初始化show和图表
     * @param {*} nextProps 
     * @param {*} nextState 
     * @returns 
     */
    _mode = (nextProps, nextState) => {
        let { mode, show } = nextState, { dimension, apis } = nextProps
        if (mode === 'chart' && !show) {
            if (!show) {
                this.setState({ show: dimension[0]?.key }, () => { this.changeChart() })
            } else if (!apis[show]) {
                this.setState({ time: new Date().getTime() }, () => { this.changeChart() })
            }
        }

        return true;
    }

    /**
     * 列表数据源监听
     * @param {*} nextProps 
     * @param {*} nextState 
     */
    _dataItems = (nextProps, nextState) => {
        let { apis } = nextProps, { mode, show } = nextState
        if (mode === 'chart' && !apis[show]) {
            this.setState({ time: new Date().getTime() }, () => { this.changeChart() })
        }
        return true;
    }

    /**
     * 搜索数据变化监听
     * @param {*} nextProps 
     * @param {*} nextState 
     * @returns 
     */
    _searchMap = (nextProps, nextState) => {
        this.changeChart(nextProps['searchMap'])
        return true;
    }

    /**
     * 公共数据监听
     * @param {*} key 
     * @param {*} nextProps 
     * @param {*} nextState 
     * @returns 
     */
    _commonDataListen = (key, nextProps, nextState) => {
        let { show, mode } = nextState, { formatData, dimension } = nextProps, _chart = 'line'
        dimension.map(({ key, chart }) => { if (key === show) { _chart = chart } })
        let data = nextProps.apiDataFormat(key, nextProps[key])
        this.buildCharts(show, mode, _chart, formatData, data)
        return true
    }

    /**
     * 构建图表出发方法
     * @param {*} searchMap 
     */
    changeChart = (searchMap = this.props.searchMap) => {
        let { show, mode } = this.state, { formatData, dataItems, dimension, apis, apiFormat } = this.props, _chart = 'line'
        //获取图表类型
        dimension.map(({ key, chart }) => { if (key === show) { _chart = chart } })
        if (apis[show]) {
            //接口获取数据
            this._doAction(show, apiFormat(show, searchMap))
        } else {
            //list format数据
            this.buildCharts(show, mode, _chart, formatData, dataItems)
        }
    }

    /**
     * 构建图表
     * @param {*} show 
     * @param {*} mode 
     * @param {*} chart 
     * @param {*} formatData 
     * @param {*} dataItems 
     */
    buildCharts = (show, mode, chart, formatData, dataItems) => {
        try {
            let container = mode + show + this.state.time
            const _chart = new G2.Chart({
                container,
                forceFit: true,
                height: 550
            });
            this._chartThis = _chart

            if (chart === 'line') {

                let { data, x, y, z } = formatData(show, dataItems)

                _chart.source(data);
                _chart.scale(y, {
                    min: 0
                });
                _chart.scale(x, {
                    range: [0, 1]
                });
                _chart.axis(x, {
                    label: {
                        textStyle: {
                            fill: '#aaaaaa'
                        }
                    }
                });
                _chart.axis(y, {
                    label: {
                        textStyle: {
                            fill: '#aaaaaa'
                        }
                    }
                });
                _chart.tooltip({
                    crosshairs: {
                        type: 'line'
                    }
                });
                _chart.legend({
                    // attachLast: true,
                    position: 'bottom', // 设置图例的显示位置
                    itemGap: 20 // 图例项之间的间距
                });
                _chart.line().position(`${x}*${y}`).color(`${z}`);

                _chart.render();
            } else if (chart == 'pie') {

                let { data } = formatData(show, dataItems, chart)
                _chart.source(data);
                //chart.legend(false);
                _chart.coord('theta', {
                    radius: 0.75
                });
                const pie = _chart.intervalStack().position('value').color('type')
                    .style({ opacity: 0.4 })
                    .select(true, {
                        style: {
                            stroke: 'black',
                            lineWidth: 2,
                            opacity: 1
                        }
                    })
                    .label('type', val => {
                        return {
                            offset: -30,
                            textStyle: {
                                //opacity,
                                fill: 'white',
                                fontSize: 12,
                                shadowBlur: 2,
                                shadowColor: 'rgba(0, 0, 0, .45)'
                            },
                            formatter: (text, item) => {
                                const d = item.point;
                                //return d.type + '\n' + d.value + '%';
                                return d.value + '%';
                            }
                        };
                    });
                _chart.render();
                pie.setSelected(data[0]);
                // _chart.on('afterpaint', () => {
                //     pie.setSelected(data[0]);
                // });
            } else if (chart === 'column') {

                let { data, x, y } = formatData(show, dataItems, chart)
                _chart.source(data);
                _chart.interval().position(`${x}*${y}`).color('name')
                    .adjust([{
                        type: 'dodge',
                        marginRatio: 1 / 32
                    }])
                _chart.render();
            } else if (chart === 'radar') {
                const { DataView } = WizDataSet;
                let { data, x, y } = formatData(show, dataItems, chart)
                const dv = new DataView().source(data);
                dv.transform({
                    type: 'fold',
                    fields: [x, y], // 展开字段集
                    key: 'user', // key字段
                    value: 'score' // value字段
                });

                _chart.source(dv, {
                    score: {
                        min: 0,
                        max: 100
                    }
                });
                _chart.coord('polar', {
                    radius: 0.8
                });
                _chart.axis('item', {
                    line: null,
                    tickLine: null,
                    grid: {
                        lineStyle: {
                            lineDash: null
                        },
                        hideFirstLine: false
                    }
                });
                _chart.axis('score', {
                    line: null,
                    tickLine: null,
                    grid: {
                        type: 'polygon',
                        lineStyle: {
                            lineDash: null
                        }
                    }
                });
                _chart.legend('user', {
                    marker: 'circle',
                    offset: 30
                });
                _chart.line().position('item*score').color('user')
                    .size(2);
                _chart.point().position('item*score').color('user')
                    .shape('circle')
                    .size(4)
                    .style({
                        stroke: '#fff',
                        lineWidth: 1,
                        fillOpacity: 1
                    });
                _chart.area().position('item*score').color('user');
                _chart.render();
            }
        } catch (error) {
            console.log('build chart error：', error)
        }

    }

    /**
   * 执行请求方法
   * @param {*} key
   * @param {*} params
   */
    _doAction = (key, params = {}) => {
        const { apis, keepInitApiParams } = this.props
        const initParams = _getInitApiParams(key, this._initApis, keepInitApiParams);
        let _p = { ...params }
        //补足参数中缺失的初始化参数
        for (const init in initParams) {
            let f = false
            for (const pKey in params) {
                if (!f && pKey === init) {
                    f = true
                    _p[pKey] = !params[pKey] ? initParams[pKey] : params[pKey]
                }
            }
            if (!f) {
                _p[init] = initParams[init]
            }
        }
        const api = _build_request(key, _p, apis);
        if (api) {
            this.doAction(api);
        } else {
            log.error("WizReduxTemplate: 未找到key为: " + key + " 的api,请检查apis!");
        }
    };

    /**
    * 获取loading状态
    */
    getLoading = () => {
        let flag = false;
        let { actionPath } = this.props;
        if (actionPath && isType(actionPath, "Array")) {
            actionPath.some((key) => {
                let _key = key + "Loading";
                if (this.props[_key]) {
                    flag = true;
                    return true;
                }
            });
        } else {
            log.error("WizReduxTemplate: 获取loading状态失败!");
        }
        return flag;
    };


    /**
    * 表格/图形切换按钮
    * @returns 
    */
    dropdown = () => {
        let menu = [], showType = { table: '表格', chart: '统计图表' }
        for (const key in showType) {
            menu.push(<WizMenu.Item key={key} disabled={this.state.mode === key}>{showType[key]}</WizMenu.Item>)
        }
        let menus = (
            <WizMenu onClick={(e) => {
                this.setState({ mode: e['key'], show: e['key'] === 'table' ? undefined : this.state.show }, () => {
                    //this.renderCharts(e['key'])
                })
            }}>
                {menu}
            </WizMenu>
        )
        return <div className='dropdown'>展示形式：
            <WizDropdown overlay={menus} >
                <WizButton>
                    {showType[this.state.mode]} <WizIcon type="down" />
                </WizButton>
            </WizDropdown>
        </div>
    }

    download = () => {
        const n = document.getElementsByClassName("download-chart")[0];
        let opts = {
            useCORS: true, // 允许加载跨域的图片
            allowTaint: false,
            tainttest: true, // 检测每张图片都已经加载完成
            logging: true,
            backgroundColor: null
        }
        html2canvas(n, opts).then(canvas => {
            const imgUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream")
            let link = document.createElement('a');
            link.href = imgUrl;
            link.download = `${new Date().getTime()}.jpg`;
            link.click();
        });
    }

    /**
     * 维度切换
     * @returns 
     */
    _tabs = () => {
        let { dimension } = this.props, { TabPane } = WizTabs;
        return (
            <WizTabs
                onChange={(e) => { this.setState({ show: e }, () => { this.changeChart() }) }}
                type="card"
                tabBarExtraContent={<WizButton onClick={() => { this.download() }}>下载统计图表</WizButton>}
            >
                {dimension.map((item) => {
                    let { key, value, otherSelect = [] } = item
                    return <TabPane tab={value} key={key}>
                        {otherSelect.length ? this._switchCharts(item) : null}
                    </TabPane>
                })}
            </WizTabs>
        )
    }

    /**
     * 开放的下拉输入框
     * @returns 
     */
    _switchCharts = (initVal) => {
        let { show } = this.state;
        let { otherSelect, selectChange } = initVal
        let columns = otherSelect.map((item, i) => {
            let { select, title, multiple, defaultSelect } = item
            return {
                title,
                name: i,
                formItem: {
                    type: 'custom',
                    render: (record, form) => {
                        const { getFieldDecorator, getFieldsValue } = form;
                        if (!multiple) {
                            return getFieldDecorator(title, {
                                initialValue: defaultSelect,
                            })(
                                <WizSelect
                                    initialValue={defaultSelect}
                                    style={{ width: '100%' }}
                                    onChange={(val) => {
                                        let allVal = getFieldsValue()
                                        allVal[title] = val
                                        selectChange(allVal, this)
                                    }}
                                >
                                    {
                                        select.map((e, i) => {
                                            return (
                                                <WizSelect.Option key={e.value}> {e.name}</WizSelect.Option>
                                            )
                                        })
                                    }
                                </WizSelect>
                            )
                        } else {

                            return getFieldDecorator(title, {
                                initialValue: defaultSelect,
                            })(
                                <WizCheckbox.Group
                                    className='diy-check-box'
                                    onChange={(val) => {
                                        let allVal = getFieldsValue()
                                        allVal[title] = val
                                        selectChange(allVal, this)
                                    }}
                                >
                                    {
                                        select.map((e, i) => {
                                            return (
                                                <WizCheckbox
                                                    key={e.value}
                                                    value={e.value}
                                                >
                                                    {e.name}
                                                </WizCheckbox>
                                            )
                                        })
                                    }
                                </WizCheckbox.Group>
                            )
                        }
                    }
                }
            }
        })
        let formProps = {
            ref: 'form',
            key: 'form' + show,
            columns,
            onSubmit: null,
            record: null,
            preview: null,
            footer: null,
            type: 'grid',
            cols: {
                xs: 7,
                md: 7,
                xl: 7
            },
            formItemLayout: {
                labelCol: { span: 6 },
                wrapperCol: { span: 16 }
            },
            style: { width: '100%' },
        }

        return (
            <WizForm className={'form-inline'} {...formProps} />
        )
    }

    _render() {
        let { mode, show, time } = this.state;
        let { table } = this.props
        let loading = this.getLoading();
        return (
            <div className='wiz-charts' >
                {this.dropdown()}
                {
                    mode === 'table'
                        ?
                        table
                        :
                        <>
                            {this._tabs()}
                            <div className='download-chart' key={mode + show + time} id={mode + show + time}></div>
                        </>
                }
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let r = {};
    let { apis } = ownProps;
    let actionPath = [];
    if (apis) {
        for (let key in apis) {
            let api = apis[key];
            let path = api["path"].split("/")[0];
            if (actionPath.indexOf(path) === -1) {
                actionPath.push(path);
            }
            r[key] = modelUtils.getModelEntity(state[path], api["payload"]["key"]);
        }
    }
    let loading = modelUtils.getLoadingState(state, actionPath);
    return {
        ...r,
        ...loading,
        actionPath,
        _datas: r,
    };
};
WizCharts.getSearchMap = getSearchMap
const options = { withRef: true };
export default connect(mapStateToProps, null, null, options)(WizCharts);

